// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + "fetch-worker" + "." + "7298f079654fee093ceb" + ".js";
};